<template>
	<div id="app" :class="[
		'app-wrap',
			!!overlay.active ? 'overlayed' : '',
			!!route && !!route.name && (route.name.indexOf('result')>-1||route.name.indexOf('all')>-1) ? 'app-results' : 'app-home',
		 	!isDevice ? 'no-touch' : '',
		  	isIE ? 'ie' : '',
		  	!!user ? '' : 'logged-out']">
		
		<div class="topSection" v-if="user">
			<top-bar></top-bar>
			<menu-bar v-if="!!user"></menu-bar>
		</div>
		<div :class="['overlaySection',shelf.active ? 'active' : '']">			
		</div>
		<div :class="['viewSection',!!user ? '' : 'logged-out']">
			<router-view key="content" v-if="loaded"></router-view>
			<preloader skin="dark" key="preloader" v-else></preloader>
		</div>		

		<!-- TEST CONTROLS -->
		<div class="testControls" style="display:none;">
			<button @click="togTestBorders('circle')" class="testBtn">Circles</button>
			&nbsp;
			<button @click="togTestBorders('box')" class="testBtn">Boxes</button>
			&nbsp;
			<!-- {{borderMode}} -->
		</div>

		<transition name="fade-delay" appear>
			<footer key="footer" v-if="loaded" id="render" :class="shelf.active ? 'shelf-active' : ''">
				<span>Copyright © 2017 MIS Implants Technologies Ltd.</span>
			</footer>
		</transition>
	</div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Preloader from '../components/Preloader.vue'
//import { store } from '@/store/index';

//await store.dispatch('initSettings');
import TopBar from './partials/TopBar.vue';
import MenuBar from './partials/MenuBar.vue';
export default {
	components: {
		TopBar,
		MenuBar,
		Preloader
	},
	computed: {
		...mapState([
			'settings',
			'overlay',
			'shelf',
			'route',
			'loaded',
			'user'
		]),
		...mapGetters([
			'isDevice',
			'isIE'
		])
	},
	methods: {
		...mapActions([
			'updateMousePos',
			'setBorderMode',
			'signInUser'
		]),
		togTestBorders(mode)
		{
			this.setBorderMode(mode);
		}
	},
	beforeRouteUpdate (to, from, next) {
		// console.log("before route update.. ", to, from);
		// if (/(root||home)/.test(to.name)) {
		// 	console.log("CLEAR SARCH FILTER");
		// 	this.searchFilterString('');

		// }
		next();
	},
	mounted() {
		let vm = this;
		//store.dispatch('initSettings');

		document.body.addEventListener('click', this.updateMousePos);
		this.$nextTick(function() {
			console.log("$route name . ", this.$route.name);
		})

	},
	destroyed() {
		document.body.removeEventListener('click', this.updateMousePos)
	}
}
</script>

<style>
	.testBtn
	{
		font-size: 12px;
		line-height: 50px;
		color: #000;
		border: 1px solid #01cefd;
		padding: 0 20px;
		background: none;
		cursor: pointer;
		white-space: nowrap;
	}
	.testBtn:hover
	{
		background-color: #01cefd;
		color:#fff;

	}
</style>

<style lang="stylus">
@import '~rupture'
@import '~settings'
html,body
	height 100%
	background-color #f9f9f9
.testControls
	padding 0%
	clear both
	padding 50px


.app-wrap
	height 100%
	// min-width 768px
	&.app-home
		//padding-top 129px
		&.logged-out
			//padding-top 49px
			padding-top 0px
	/.ie &.overlayed
		height auto
	&:after
		content ''
		display table
		clear both
	+below(815px)
		width 100vw
		overflow-x hidden
	+mobile__
		width 100vw
		height 100vh
		min-width auto
		overflow hidden
		background url(/img/mobile-not-supported-portrait.jpg) no-repeat 100% 100% / cover
		*
			display none
		+landscape()
			background-image url(/img/mobile-not-supported-landscape.jpg)
.topSection
	height 220px
	overflow hidden
	background-color #f9f9f9
	position fixed
	top 0px
	left 0px
	width 100vw
	z-index 1000
	+tablet()
		height 160px
	+below(815px)
		height 160px
.viewSection
	padding-top 220px 
	min-height calc(100vh - 70px)
	+tablet()
		padding-top 170px
	+below(815px)
		//padding-top 160px 
		padding-top 160px
	&.logged-out
		padding-top 0px
.overlaySection
	position fixed
	z-index 1500
	top 0px
	left 0px
	width 100vw
	height 100vh
	background-color #fff
	opacity 0
	pointer-events none
	transition all ease 0.5s
	&.active
		opacity 0.75

footer
	width 100%
	height 78px
	min-width 768px
	background #2e2e2e
	lost-align center
	transform translateY(0)
	transition transform 0.4s ease-out
	+below(815px)
		lost-align left
		text-align center
		width 100vw
		min-width 100vw

	.results + &
		border-top 1px solid #50595e
		background #061016
	span
		font-size 10px
		color #bcbcbd
		opacity 0.5
		+below(815px)
			margin auto
			display block
			position relative
			color #fff
			width 100vw
	&.shelf-active
		//transform translateY(475px)
		//+below(1400px)
			//transform translateY(355px)

.home + footer
	height 40px
	width 100%
	border-top 1px solid rgba(#fff, 0.5)
	background linear-gradient(to bottom, #212121, darken(darkblue, 9) 20%)
	box-shadow -2px -2px 25px rgba(33,33,33,0.3)
	span
		color #fff
		+below(815px)
			text-align center
			width 100%
	z-index 2
	+below(815px)	
		width 100vw
		min-width initial
		max-width 100vw
.single-line + footer:not(.shelf-active)
	border-top 0
	transform none
</style>